export const GET_TOURSCREEN_USERS_LIST_START =
  "GET_TOURSCREEN_USERS_LIST_START";
export const GET_TOURSCREEN_USERS_LIST_SUCCESS =
  "GET_TOURSCREEN_USERS_LIST_SUCCESS";
export const GET_TOURSCREEN_USERS_LIST_FAILURE =
  "GET_TOURSCREEN_USERS_LIST_FAILURE";
export const ON_CHANGE_APPLY_TOUR_SCREEN_FILTER= "ON_CHANGE_APPLY_TOUR_SCREEN_FILTER"